import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';
import { allocationTypeSchema } from './allocation-type.schema';

export const purchaseOrderSchema = z.object({
  allocationType: allocationTypeSchema,
  purchaseCount: z.number().min(1),
  purchaseOrderNumber: z.string().nullable(),
  purchaseDate: coercedDate,
});

export type PurchaseOrder = z.infer<typeof purchaseOrderSchema>;
